enum ButtonText {
  // General
  ClearForm = 'Clear form',
  CopyToClipboard = 'Copy to clipboard',
  Submit = 'Submit',
  CreateDraftReply = 'Create draft reply',
  DraftReply = 'Draft Reply',
  DraftReplyAll = 'Draft Reply All',
  DraftEmail = 'Draft Email',
  Send = 'Send Email',
  AddReplyToCurrentDraft = 'Add reply to current draft',

  // Load Building
  BuildLoad = 'Build Load',

  // Carrier Quote
  AddCarrierNetworkQuoteDraft = 'Add Email',
  CancelCarrierEmail = 'Cancel email',
  FindCarriers = 'Find Carriers',
  EmailCarriers = 'Email Selected Carriers',

  // Outbox
  RescheduleCarrierEmail = 'Reschedule email',
  UndoCancelCarrierEmail = 'Undo cancel email',
  UpdateCarrierEmail = 'Save edits',
  GoToOutboxTab = 'Go to Outbox',

  // Quick Quote
  GetQuickQuote = 'Get Quick Quote',
  GetLTLQuickQuote = 'Get LTL Quote',
  EnableDATForUser = 'Enable',
  SubmitQuoteToTMS = 'Save quote',
  SubmitQuoteViaURL = 'Submit quote via URL',

  // Batch Quote
  GetBatchQuote = 'Get Batch Quote',

  // Appointment Scheduling
  ConfirmSlotApptScheduling = 'Confirm appointment',
  GetOpenApptSlots = 'Get open slots',
  ShowSmartReply = 'Show Smart Reply',
  ValidatePONumbers = 'Validate PO numbers',

  // Truck Lists
  CreatePickupGroupForTruckList = 'Add new pickup date',
  IngestEmail = 'Process Email',
  SubmitTruckListWithServiceName = 'Submit to',
  ValidateTruckListCarrier = 'Validate Carrier',

  // Track & Trace
  ScheduleCarrierEmails = 'Schedule emails',
  ScheduleShipperEmails = 'Schedule shipper emails',
  SubmitCheckCall = 'Submit check call',
  SubmitException = 'Submit exception',
  SubmitNote = 'Submit note',

  // Load Info
  SearchLoad = 'Search',
  UpdateTMS = 'Save',
  CancelLoad = 'Cancel Load',

  // AI Suggestions
  SkipSuggestion = 'Skip Suggestion',
}

export default ButtonText;
